<template>
  <div class="orderManager">
    <div class="item">
      <div class="title">控制价审核</div>
      <el-table
        ref="multipleTable"
        :data="pricetableData"
        border
        size="mini"
        style="width: 100%"
      >
        <el-table-column type="selection" width="54"></el-table-column>
        <el-table-column
          v-for="(item, index) in pricetableColumns"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        >
          <!-- <template slot-scope="scope"> -->
            <!-- <span v-if="item.isNumFilter">{{
                scope.row[scope.column.property] | numFilter
              }}</span>
              <span v-else-if="item.contractType">{{
                scope.row[scope.column.property] === "TEMPORARY" ? "是" : "否"
              }}</span> -->
            <!-- <span>{{ scope.row[scope.column.property] }}</span> -->
          <!-- </template> -->
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="bidPlanDetail(scope.row,'price')"
              >详情</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="delBid(scope.row,'price')"
              >作废</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="item">
      <div class="title">采购文件审核</div>
      <el-table
        ref="multipleTable"
        :data="filetableData"
        border
        size="mini"
        style="width: 100%"
      >
        <el-table-column type="selection" width="54"></el-table-column>
        <el-table-column
          v-for="(item, index) in filetableColumns"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        >
          <!-- <template slot-scope="scope"> -->
            <!-- <span v-if="item.isNumFilter">{{
                scope.row[scope.column.property] | numFilter
              }}</span>
              <span v-else-if="item.contractType">{{
                scope.row[scope.column.property] === "TEMPORARY" ? "是" : "否"
              }}</span> -->
            <!-- <span>{{ scope.row[scope.column.property] }}</span> -->
          <!-- </template> -->
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="bidPlanDetail(scope.row,'file')"
              >详情</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="delBid(scope.row,'file')"
              >作废</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="item">
      <div class="title">联签单审核</div>
      <el-table
        ref="multipleTable"
        :data="ordertableData"
        border
        size="mini"
        style="width: 100%"
      >
        <el-table-column type="selection" width="54"></el-table-column>
        <el-table-column
          v-for="(item, index) in ordertableColumns"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="bidPlanDetail(scope.row,'order')"
              >详情</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="delBid(scope.row,'order')"
              >作废</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  getAllContractList, //获取总包合同列表接口
  deleteOneAllContractSevice, //删除一条总包合同数据
} from "@/services/allContractServices";
import {
  getsubDeptService, //获取项目部二级项目级联列表
} from "@/services/sysSettingService";
export default {
  name: "bidPlanMsg",
  props: {
    menuCode: {
      type: String,
    },
  },
  data() {
    return {
      ProjectGMList: [], //审批对话框项目经理下拉列表
      pricetableColumns: [
        { class: "name", labelName: "项目名称", sortEnable: false },
        { class: "partyA", labelName: "提报单位/部门", sortEnable: false },
        { class: "partyB", labelName: "审核内容", sortEnable: false },
        { class: "signPlace", labelName: "审核金额", sortEnable: false },
        { class: "applyUserName", labelName: "采购计划编号", sortEnable: false },
        { class: "applyDeptName", labelName: "提交人", sortEnable: false },
        { class: "signDate", labelName: "提交时间", sortEnable: false },
        { class: "signDate", labelName: "审核状态", sortEnable: false },
        { class: "signDate", labelName: "是否作废", sortEnable: false },
      ],
      filetableColumns: [
        { class: "name", labelName: "项目名称", sortEnable: false },
        { class: "name", labelName: "项目情况", sortEnable: false },
        { class: "partyA", labelName: "提报单位", sortEnable: false },
        { class: "partyB", labelName: "提报单位负责人", sortEnable: false },
        { class: "signPlace", labelName: "采购计划编号", sortEnable: false },
        { class: "applyUserName", labelName: "经办人", sortEnable: false },
        { class: "applyDeptName", labelName: "提交人", sortEnable: false },
        { class: "signDate", labelName: "提交时间", sortEnable: false },
        { class: "signDate", labelName: "审核状态", sortEnable: false },
        { class: "signDate", labelName: "是否作废", sortEnable: false },
      ],
      ordertableColumns: [
      { class: "name", labelName: "项目名称", sortEnable: false },
        { class: "name", labelName: "项目情况", sortEnable: false },
        { class: "partyA", labelName: "提报单位", sortEnable: false },
        { class: "partyB", labelName: "提报单位负责人", sortEnable: false },
        { class: "signPlace", labelName: "采购计划编号", sortEnable: false },
        { class: "applyUserName", labelName: "经办人", sortEnable: false },
        { class: "applyDeptName", labelName: "提交人", sortEnable: false },
        { class: "signDate", labelName: "提交时间", sortEnable: false },
        { class: "signDate", labelName: "审核状态", sortEnable: false },
        { class: "signDate", labelName: "是否作废", sortEnable: false },
      ],
      showAdvanceFilter: false,
      pricetableData: [],
      filetableData: [],
      ordertableData: [],
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        import: { key: "import", btnEnable: false }, //导入
        callback: { key: "callback", btnEnable: false }, //审核
        export: { key: "export", btnEnable: false },
        uploadFileBtn: { key: "uploadFileBtn", btnEnable: false },
      },
    };
  },
  mounted() {
    this.initList(); //获取下拉列表  gaa 20200806
  },
  methods: {
    handleTimestamp() {
      this.$forceUpdate();
    },
    //点击查询
    handleClick() {
      this.initList();
    },
    //获取总包合同列表
    initList() {
      let param = {
        // currentUserId: this.currentUserId, // sessionStorage.getItem("userCode"),
        // sort: "name",
        // order: "asc",
        tabIndex:1,
        pageIndex:1,
        pageSize: 10,
      };
      getAllContractList(param, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.pricetableData = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, 
    //作废
    delBid(row, type) {
      let param = {};
      param.id = row.id;
      if(type=='price'){  //控制价审核作废
        param.routeId = "controlPriceDetail";
      // param.uploadBtn = this.btnAuthorize.uploadFileBtn.btnEnable;
      this.bus.$emit("navMenuChange", {
        routeId: "controlPriceDetail",
        routeParam: param,
      });

      }else if(type=='file'){
        param.routeId = "bidPlanDetail";
      // param.uploadBtn = this.btnAuthorize.uploadFileBtn.btnEnable;
      this.bus.$emit("navMenuChange", {
        routeId: "bidPlanDetail",
        routeParam: param,
      });

      }else if(type=='file'){
        param.routeId = "bidPlanDetail";
      // param.uploadBtn = this.btnAuthorize.uploadFileBtn.btnEnable;
      this.bus.$emit("navMenuChange", {
        routeId: "bidPlanDetail",
        routeParam: param,
      });

      }
      
     
    },

    //双击跳转详情
    bidPlanDetail(row, type) {
      let param = {};
      param.id = row.id;
      if(type=='price'){  //控制价审核
        param.routeId = "controlPriceDetail";
      // param.uploadBtn = this.btnAuthorize.uploadFileBtn.btnEnable;
      this.bus.$emit("navMenuChange", {
        routeId: "controlPriceDetail",
        routeParam: param,
      });

      }else if(type=='file'){
        param.routeId = "bidPlanDetail";
      // param.uploadBtn = this.btnAuthorize.uploadFileBtn.btnEnable;
      this.bus.$emit("navMenuChange", {
        routeId: "bidPlanDetail",
        routeParam: param,
      });

      }else if(type=='file'){
        param.routeId = "bidPlanDetail";
      // param.uploadBtn = this.btnAuthorize.uploadFileBtn.btnEnable;
      this.bus.$emit("navMenuChange", {
        routeId: "bidPlanDetail",
        routeParam: param,
      });

      }
      
     
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.orderManager {
  height: 100%;
  background-color: white;

  .item {
    .title {
      height: 44px;
      // padding-left: 24px;
      box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
      border-radius: 2px 2px 0px 0px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 44px;
      text-align: left;
      margin-bottom: 10px;
    }
  }
}
</style>
